import { render, staticRenderFns } from "./DetailsRequest.vue?vue&type=template&id=8099b9b0&scoped=true"
import script from "./DetailsRequest.vue?vue&type=script&lang=js"
export * from "./DetailsRequest.vue?vue&type=script&lang=js"
import style0 from "./DetailsRequest.vue?vue&type=style&index=0&id=8099b9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8099b9b0",
  null
  
)

export default component.exports